module.exports = require('./helpers/bundle-url').getBundleURL('jJw6J') + "logo.c51670a8.svg";